import { ResourcePayload } from '_api/types';
import {
  CheckboxField,
  FileInputField,
  InputField,
} from 'components/molecules/formFields';
import React, { useState } from 'react';

import { FormBuilder } from './form-builder';
import { BaseFormProps } from './types';

export const ResourceForm = ({
  disableAll = false,
  hideSubmitButtons = false,
  initValue,
  onSubmit,
  onBack,
}: BaseFormProps<ResourcePayload>) => {
  const [isUploadingFile, setIsUploadingFile] = useState(false);
  const formFields = [
    {
      component: InputField,
      fieldKey: 'title',
      label: 'RESOURCE TITLE',
      required: true,
      xs: 12,
    },
    {
      component: InputField,
      fieldKey: 'description',
      label: 'DESCRIPTION',
      type: 'textarea',
      multiline: true,
      required: true,
      rows: 4,
    },
    {
      component: FileInputField,
      fieldKey: 'imageUrl',
      label: 'THUMBNAIL IMAGE',
      isUploadingFile: (uploading: boolean) => setIsUploadingFile(uploading),
      xs: 4,
    },
    {
      component: InputField,
      fieldKey: 'url',
      label: 'URL',
      xs: 4,
    },
    {
      component: FileInputField,
      fieldKey: 'documentUrl',
      label: 'DOCUMENT',
      acceptFileType: 'application/pdf',
      isUploadingFile: (uploading: boolean) => setIsUploadingFile(uploading),
      xs: 4,
    },
    {
      component: CheckboxField,
      fieldKey: 'shareWithOrg',
      label: 'SHARE',
      checkboxLabel: 'Share with Your Organization',
      xs: 4,
    },
  ];

  return (
    <FormBuilder
      disabled={disableAll}
      disableSubmit={isUploadingFile}
      initValues={initValue}
      formFields={formFields}
      onSubmit={onSubmit}
      onBack={onBack}
      hideSubmit={hideSubmitButtons}
    />
  );
};
